import { WordingMultiAstrologyMeditationLove } from '@/types';

export const MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_SI: WordingMultiAstrologyMeditationLove = {
  components_header_media_content: 'Astrologija',
  components_header_media_multi_content_2: 'Meditacija',
  components_header_media_multi_content_3: 'Ljubezen',
  components_header_text1: 'Vodniki',
  components_header_text2: 'Blog',
  hero_text: 'Poiščite jasnost, ravnovesje in povezanost.',
  hero_button_text: 'Začnite svojo pot',
  components_ressources_subheader_text: 'Nasveti in navdih',
  components_ressources_span_text: 'Združuje osebne astrološke vpoglede, pomirjujoče meditacijske prakse in premišljeno ljubezensko vodstvo za podporo samoodkrivanju, čustvenemu ravnovesju in globlji povezanosti.',
  components_ressources_card_1_title: 'Nasveti za meditacijo',
  components_ressources_card_1_text: 'Hiter vodnik za boljšo umirjenost, dihanje in osredotočenost.',
  components_ressources_card_2_title: 'Ljubezensko vodstvo',
  components_ressources_card_2_text: 'Preprosti nasveti za vzpostavitev močnejše povezave in čustvenega ravnovesja.',
  components_ressources_link: 'Odkrijte več',
  components_notes_and_google_title_1: 'Najdi jasnost',
  components_notes_and_google_title_2: 'Notranji mir',
  components_notes_and_google_title_3: 'Povezava s srcem',
  media_content_section_multi_1_subheader_text: 'Naš podkast',
  media_content_section_multi_2_subheader_text: 'Naše meditacije',
  media_content_section_multi_3_subheader_text: 'Resni pogovor o kozmični romanci',
  page_media_content_menu_antistress: 'Protistresno',
  page_media_content_menu_mindfulness: 'Čuječnost',
  page_media_content_menu_energyboost: 'Energijski dvig',
  page_media_content_menu_mantra: 'Mantra',
  page_media_content_menu_foundations: 'Temelji',
  page_media_content_menu_spirituality: 'Duhovnost',
  page_media_content_menu_tarot: 'Tarot',
  page_media_content_menu_psychology: 'Psihologija',
  page_media_content_menu_trends: 'Trendi',
  page_media_content_menu_compatibility: 'Združljivost',
  page_media_content_menu_love: 'Ljubezen',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Članki in vpogledi',
  text2_section_button_more: 'Naloži več',
  components_text1_section_title: 'VODNIKI',
  components_text1_subheader_text: 'Kozmično znanje za dnevno usklajenost',
  components_text1_span_text: 'Uskladite se z ritmi vesolja: raziščite kurirano zbirko poglobljenih astroloških in meditativnih vodnikov, zasnovanih za prebujanje notranje jasnosti, poglobitev samozavedanja in podporo vaši poti duhovne, nebeške rasti.',
  components_text1_card_1_title: 'Odprto za tišino',
  components_text1_card_1_text: 'Začnite svojo pot z vodniki za temeljno meditacijo in astrologijo – idealno za iskalce, ki jih privlači notranja tišina, kozmični vzorci in osebni vpogled.',
  components_text1_card_3_title: 'Povezava med umom in telesom',
  components_text1_card_3_text: 'Odkrijte globlje plasti svojega notranjega sveta. Ti vodniki se pomikajo pod površino in razkrivajo pomen, čustva in vzorce čuječnosti, ki oblikujejo vašo izkušnjo.',
  components_text1_card_2_title: 'Razmišljanje in povezovanje',
  components_text1_card_2_text: 'Od čustvenih blokad do planetarnih ciklov – ti vodniki ponujajo orodja za refleksijo, zdravljenje in preobrazbo s pomočjo čuječih ritualov in astrološke modrosti.',
  components_text1_link: 'Ogled vseh vodnikov',
  components_footer_text: 'Poiščite jasnost, uravnovesite svoj um in se povežite s pomenom – vaš prostor za astrologijo, meditacijo in ljubezen.',
};